<template>
  <v-container class="nl-theme-background">
    <v-row>
      <v-col cols="6">
        <v-card
          class="py-4"
          color="transparent"
          dark
          flat
        >
          <v-card-title
            class="display-2 py-0"
            primary-title
          >
            Get started today
          </v-card-title>
          <v-card-text>
            Create your account
          </v-card-text>
          <!--v-card-actions>
            <v-btn
              disabled
              large
              light
            >
              Sign up with Google
            </v-btn>
            <v-btn
              disabled
              color="indigo"
              dark
              large
            >
              Sign up with Facebook
            </v-btn>
          </v-card-actions-->
        </v-card>
      </v-col>
      <v-col cols="6">
        <validation-observer
          v-slot="{ invalid, validated, passes }"
          ref="form"
        >
          <v-form>
            <v-container>
              <v-row
                align="center"
              >
                <v-col
                  class="form-row"
                  cols="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    name="email"
                    rules="required|email"
                  >
                    <v-text-field
                      v-model="user.email"
                      :error-messages="errors"
                      color="white"
                      dark
                      label="Email Address"
                      type="email"
                      autocomplete="username"
                      required
                    />
                  </validation-provider>
                </v-col>
                <v-col
                  class="form-row"
                  cols="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    name="firstname"
                    rules="required"
                  >
                    <v-text-field
                      v-model="user.firstName"
                      :error-messages="errors"
                      color="white"
                      dark
                      label="First name"
                      required
                    />
                  </validation-provider>
                </v-col>
                <v-col
                  class="form-row"
                  cols="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    name="lastname"
                    rules="required"
                  >
                    <v-text-field
                      v-model="user.lastName"
                      :error-messages="errors"
                      color="white"
                      dark
                      label="Last name"
                      required
                    />
                  </validation-provider>
                </v-col>
                <v-col
                  class="form-row"
                  cols="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    name="password"
                    rules="required|minPassword:8"
                  >
                    <v-text-field
                      v-model="user.password"
                      :error-messages="errors"
                      color="white"
                      dark
                      label="Password"
                      type="password"
                      autocomplete="new-password"
                      required
                    />
                  </validation-provider>
                </v-col>
                <v-col
                  class="form-row"
                  cols="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    name="confirmation"
                    rules="password:@password"
                  >
                    <v-text-field
                      v-model="user.confirmPassword"
                      :error-messages="errors"
                      color="white"
                      dark
                      label="Confirm password"
                      type="password"
                      autocomplete="new-password"
                      required
                    />
                  </validation-provider>
                </v-col>
                <v-col
                  class="form-row"
                  cols="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    rules="agree"
                    name="agree"
                  >
                    <v-checkbox
                      v-model="agree"
                      :error-messages="errors"
                      color="white"
                      dark
                      required
                    >
                      <template #label>
                        <div>
                          I agree to the
                          <TermsDialog />
                        </div>
                      </template>
                    </v-checkbox>
                  </validation-provider>
                </v-col>
                <v-spacer />
                <v-col
                  class="form-row"
                  cols="5"
                >
                  <v-btn
                    block
                    large
                    @click="passes(submit)"
                  >
                    Create your account
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            <plan-checkout-button
              ref="stripeCheckout"
              :plan="plan"
              success-url="profile/new"
              hidden
            />
          </v-form>
        </validation-observer>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapActions } from 'vuex';

import NeuralikeTermsDialog from '@/layout/BottomDrawer/neuralikeDialogs/NeuralikeTermsDialog.vue';
import OpenvoxelTermsDialog from '@/layout/BottomDrawer/openvoxelDialogs/OpenvoxelTermsDialog.vue';
import PlanCheckoutButton from '@/components/PlanCheckoutButton.vue';

const theme = process.env.VUE_APP_THEME;

extend('agree', {
  validate(value) {
    return value === true;
  },
  message: 'You must agree the terms of usage',
});

export default {
  name: 'RegisterPanel',
  components: {
    PlanCheckoutButton,
    TermsDialog: theme === 'openvoxel' ? OpenvoxelTermsDialog : NeuralikeTermsDialog,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    plan: {
      type: String,
      default: 'free',
    },
  },
  data() {
    return {
      user: {
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
      },
      agree: false,
    };
  },
  methods: {
    ...mapActions('auth', [
      'registerUser',
      'login',
    ]),
    ...mapActions('profile', [
      'setProfileData',
    ]),
    async submit() {
      if (!this.$refs.form.validate()) {
        return;
      }
      const data = await this.registerUser(this.user);

      if (data !== null) {
        this.$refs.form.setErrors(data);
        return;
      }

      if (this.plan === 'free') {
        this.$router.push({
          name: 'createProfile',
        });
      } else {
        this.$refs.stripeCheckout.redirectToCheckout();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-row {
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}
</style>
